export const getIsCartFlyoutOpen = (state) => state?.cartFlyout?.isOpen
